/**
 * Global API Configuration for PolyVideo
 * 
 * This file contains the API base URL and all endpoint paths.
 * Change API_BASE_URL to point to your backend server.
 */

// API Base URL - Change this to your deployed backend URL
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

/**
 * API Endpoints
 */
export const API_ENDPOINTS = {
  // Polymarket endpoints
  POLYMARKET_INFO: '/api/polymarket/info',
  
  // Price endpoints
  PRICES_HISTORY: '/api/prices/history',
  PRICES_ANALYTICS: '/api/prices/analytics',
  
  // YouTube endpoints
  YOUTUBE_INFO: '/api/youtube/info',
};

/**
 * Helper function to build full API URL
 * @param {string} endpoint - Endpoint path from API_ENDPOINTS
 * @returns {string} Full API URL
 */
export const getApiUrl = (endpoint) => {
  return `${API_BASE_URL}${endpoint}`;
};

/**
 * Set custom API base URL (useful for production deployment)
 * @param {string} url - New base URL
 */
export const setApiBaseUrl = (url) => {
  // This would require state management (Redux/Context) for dynamic updates
  console.warn('Use REACT_APP_API_URL environment variable to set API URL');
};

const apiConfig = {
  API_BASE_URL,
  API_ENDPOINTS,
  getApiUrl,
  setApiBaseUrl
};

export default apiConfig;

